import { Injectable } from '@angular/core';
import { BaseHttpClient } from '@peca/commons';
import { environment } from 'apps/backoffice/src/environments/environment';

import { CreateBranchRestrictionDto, UpdateBranchRestrictionDto, BranchRestrictionDto } from '../types/commercial-restrict.type';

@Injectable({ providedIn: 'root' })
export class CommercialRestrictService extends BaseHttpClient {
  private readonly resource = `${environment.gateway.url}/backoffice/v2/branch-restrictions`;

  list() {
    return this.http.get<BranchRestrictionDto[]>(this.resource);
  }

  create(payload: CreateBranchRestrictionDto) {
    return this.http.post<BranchRestrictionDto>(this.resource, payload);
  }

  getById(id: string) {
    return this.http.get<BranchRestrictionDto>(`${this.resource}/${id}`);
  }

  update(id: string, payload: UpdateBranchRestrictionDto) {
    return this.http.put<BranchRestrictionDto>(`${this.resource}/${id}`, payload);
  }

  remove(id: string) {
    return this.http.delete<void>(`${this.resource}/${id}`);
  }
}
